import {SET_NOTIFICATION_COUNTER_AMOUNT} from "../constans";

const defaultState = {
    amount: 0
};

const notificationCountersReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_NOTIFICATION_COUNTER_AMOUNT: return {...state, amount: action.payload }; break;
        default: return state;
    }
}

export default notificationCountersReducer;